import { Link } from "react-router";

/**
 * Teks kontak (nama/perusahaan) yang menaut ke halaman detail kontak bila
 * contactId tersedia; fallback teks biasa / "—" bila kosong.
 */
const ContactDetailLink = ({ contactId, children }) => {
  if (children == null || children === "") return "—";
  if (contactId == null) return children;
  return (
    <Link
      to={`/contacts/detail/${contactId}`}
      className="text-[#1677ff] underline underline-offset-1"
    >
      {children}
    </Link>
  );
};

export default ContactDetailLink;
